import React, { Component } from 'react';

class SetupHolder extends Component {
	render() {
		return(
			<h2 id='setup_holder'>
				{this.props.setup}
			</h2>
			)
	}
}

export default SetupHolder;